export const ru = {
    'recall': 'Перезвонить',
    'button-microphone-off': 'Выключить микрофон',
    'button-microphone-on': 'Включить микрофон',
    'button-camera-on': 'Включить камеру',
    'button-camera-off': 'Выключить камеру',
};
